import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentManagementService {

  constructor(private _http : HttpClient) { }

  getContentManagementData(): Observable<any>{
    return this._http.get<any>(environment.config.BASE_API_URL + 'contentmanagement/GetContentManagementData');
  }

  getContentManagementByPageID(pageId){
    return this._http.get<any>(environment.config.BASE_API_URL + 'contentmanagement?pageId=' + pageId);
  }

  saveContentManagement(mod){
    return this._http.post<any>(environment.config.BASE_API_URL + 'contentmanagement', mod);
  }
}
